import { Box } from "@mui/material";
import { motion } from "framer-motion";

export const RedDot = ({ style }: { style?: React.CSSProperties }) => {
  return (
    <Box
      component={motion.div}
      style={style}
      animate={{
        scale: [1, 2, 1, 2, 1],
      }}
      transition={{
        duration: 0.7,
        ease: "easeInOut",
      }}
      position="absolute"
      bgcolor="red"
      height={8}
      width={8}
      right={-2}
      top={3}
      zIndex={10}
      color={"red"}
      borderRadius="100%"
    />
  );
};
